<template>
   <div class="footer">
     <div class="container">
       <div class="copyright">© {{currentYear}} Service Portal v{{version}}</div>
       <div class="made-by"></div>
    </div>
   </div>
</template>

<script>
export default {
  name: 'Footer',
  data: function() {
    return {
      currentYear: new Date().getFullYear(),
      version: "1.2.2"//__VERSION__ // eslint-disable-line no-undef
    };
  }
};
</script>

<style scoped>
.footer {
  background: #18385f;
  height:36px;
  width: 100%;
}

.footer .container {
  font-size: 0.9em;
}

.copyright {
  line-height: 36px;
  color: white;
  display: inline-block;
  float: left;
}

.made-by {
  line-height: 36px;
  color: white;
  display: inline-block;
  float: right;
}
</style>
